import { render, staticRenderFns } from "./SenderHeader.vue?vue&type=template&id=3c45f9b6&scoped=true"
import script from "./SenderHeader.vue?vue&type=script&lang=js"
export * from "./SenderHeader.vue?vue&type=script&lang=js"
import style0 from "./SenderHeader.vue?vue&type=style&index=0&id=3c45f9b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c45f9b6",
  null
  
)

export default component.exports